<template>
  <div class="dashboard">
    <div class="site-wrapper">
        <div class="main-wrapper">
            <div v-if="user" class="container-fluid">
                <div class="header-teacher mb-5 bg-primary rounded-lg text-white">
                    <div class="inner p-5" style="padding-bottom: 12px !important">
                        <div class="row align-items-center">
                            <div class="col-lg-8 col-left">
                                <div class="row align-items-center">
                                    <div class="col-lg-4 text-lg-center">
                                        <img :src="user.pic | getMediaUrl" class="rounded-lg mw-100" alt="" style="width: 240px; height: 240px">
                                    </div>
                                    <div class="col-lg-8 text-lg-left">
                                        <div class="name -block">
                                          <h3 class="mb-3" style="font-weight: bold">{{ user.fullname }}</h3>
                                        </div>
                                        <div>
                                            <div>Công việc:</div>
                                            <ul>
                                              <li v-for="(job, index) in user.job_titles" :key="index">{{ job }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-right">
                                <div class="h-100 align-items-center">
                                    <h6>Liên hệ</h6>
                                    <ul v-if="user.contact" class="list-unstyled mt-3">
                                        <li v-if="user.contact.facebook" class="mb-2 d-flex align-items-center">
                                            <div class="btn btn-icon bg-white sm rounded-circle mr-3">
                                              <img src="@/assets/images/icons/facebook.svg" style="max-width: 16px; max-height: 16px" />
                                            </div>
                                            <a href="#" class="text-white">{{ user.contact.facebook }}</a>
                                        </li>
                                        <li v-if="user.contact.youtube" class="mb-2 d-flex align-items-center">
                                            <div class="btn btn-icon bg-white sm rounded-circle mr-3">
                                                <img src="@/assets/images/icons/youtube.svg" style="max-width: 16px; max-height: 16px" />
                                            </div>
                                            <a href="#" class="text-white">{{ user.contact.youtube }}</a>
                                        </li>
                                        <li v-if="user.contact.website" class="mb-2 d-flex align-items-center">
                                            <div class="btn btn-icon bg-white sm rounded-circle mr-3">
                                                <b-icon-link class="text-success" />
                                            </div>
                                            <a href="#" class="text-white">{{ user.contact.website }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center" style="flex-direction: row-reverse">
                          <div class="d-flex align-items-center">
                            <!-- <div class="btn btn-icon bg-white sm rounded-circle mr-3" @click="handleEditInfo">
                              <b-icon-pencil font-scale="0.85"/>
                            </div> -->
                          </div>
                        </div>
                    </div>
                </div>

                <div class="teacher-info container-fluid mb-5">
                  <div class="row no-gutter">
                    <div class="col-12 col-lg-6 p-0">
                      <div class="info-block">
                        <div class="title">Thông tin giảng viên</div>
                        <div class="overview mt-5">
                          <div class="container-fluid">
                            <div class="row teacher-overview">
                              <div class="col-6 col-md-3 overview-card pb-1">
                                <div class="inner">
                                  <div class="value">{{ getTeacherRatingPoint || 0 }}</div>
                                  <div class="title">Đánh giá</div>
                                </div>
                              </div>
                              <div class="col-6 col-md-3 overview-card pb-1">
                                <div class="inner">
                                  <div class="value">{{ user.statistics.student_count || 0 }}</div>
                                  <div class="title">Học viên</div>
                                </div>
                              </div>
                              <div class="col-6 col-md-3 overview-card pb-1">
                                <div class="inner">
                                  <div class="value">{{ user.statistics.course_count || 0 }}</div>
                                  <div class="title">Khóa học</div>
                                </div>
                              </div>
                              <div class="col-6 col-md-3 overview-card pb-1">
                                <div class="inner">
                                  <div class="value">{{ user.statistics.rating.count || 0 }}</div>
                                  <div class="title">Nhận xét</div>
                                </div>
                              </div>
                            </div>
                            <div class="row teacher-about mt-5">
                              <div class="about-title pb-2 w-100 d-flex justify-content-between align-items-center">
                                <span class="text">Mô tả giảng viên</span>
                                <!-- <span style="color: #848B96; font-weight: bold; cursor: pointer" @click="handleEditInfo">
                                  <span class="pr-1">Chỉnh sửa</span>
                                  <b-icon-pencil />
                                </span> -->
                              </div>
                              <div class="about-content pt-3" v-html="user.about"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="info-block">
                        <div class="title d-flex">
                          <span>Nhận xét về giảng viên</span>
                          <span class="text-white tool-box ml-3 d-flex align-items-center">
                            <b-icon-chat-right-text />
                            <span class="pl-3">{{ user.statistics.rating.count || 0 }}</span>
                          </span>
                        </div>
                        <div class="teacher-rating mt-5">
                          <div class="container-fluid">
                            <div v-if="ratings && ratings.list" class="row">
                              <div
                                class="col-6 pb-4"
                                v-for="rating in ratings.list"
                                :key="rating._id"
                              >
                                <div class="inner">
                                  <div class="user-rating p-2">
                                    <div class="rating-header d-inline-flex align-items-start justify-content-between">
                                      <img class="avatar" :src="rating.user.profile.pic | getMediaUrl" alt="USER">
                                      <span class="name-rating">
                                        <div class="text-left" style="padding: 0 0.25em">{{ rating.user.profile.fullname }}</div>
                                        <div class="rating-star">
                                          <b-form-rating
                                            inline
                                            :value="rating.points"
                                            :readonly="true"
                                            :no-border="true"
                                            color="#FFD217"
                                            style="background-color: transparent;"
                                          />
                                        </div>
                                      </span>
                                    </div>
                                    <div class="rating-content p-2">
                                      {{ rating.comment }}
                                    </div>
                                    <div class="rating-bottom d-flex justify-content-end pt-3">
                                      <span class="rating-time">{{ rating.created |  getDateTime }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>

        <b-modal
          v-model="infoDialog"
          title="Cập nhật thông tin"
          dialog-class="info-dialog"
          ok-title="Lưu thay đổi"
          ok-only
          size="lg"
          @ok="updateInfo"
        >
          <b-form>
            <b-form-group
              label="Họ và tên"
            >
              <b-form-input
                v-model="infoTemp.fullname"
                required
              />
            </b-form-group>

            <b-form-group
              label="Website"
            >
              <b-form-input
                v-model="infoTemp.contact.website"
                required
              />
            </b-form-group>

            <b-form-group
              label="Email"
            >
              <b-form-input
                v-model="infoTemp.contact.email"
                required
              />
            </b-form-group>

            <b-form-group
              label="Facebook"
            >
              <b-form-input
                v-model="infoTemp.contact.facebook"
                required
              />
            </b-form-group>

            <b-form-group
              label="Youtube"
            >
              <b-form-input
                v-model="infoTemp.contact.youtube"
                required
              />
            </b-form-group>

            <b-form-group
              label="Mô tả"
            >
              <b-form-textarea
                v-model="infoTemp.about"
                rows="3"
                max-rows="6"
                required
              />
            </b-form-group>
          </b-form>
        </b-modal>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'user',
      ratings: 'ratings'
    }),
    getTeacherRatingPoint() {
      const sum = _.get(this.user, 'statistics.rating.points_sum') || 0
      const count = _.get(this.user, 'statistics.rating.count') || 1

      return (sum / count).toFixed(2)
    },
    getRatingPoint() {
      const sum = _.get(this.course, 'statistics.rating.points_sum') || 0
      const count = _.get(this.course, 'statistics.rating.count') || 1

      return (sum / count).toFixed(2)
    }
  },

  data() {
    return {
      infoDialog: false,
      infoTemp: {
        contact: {}
      },
      ratingQuery: {
        page: 1,
        limit: 100
      }
    }
  },

  created() {
    this.init()
  },

  methods: {
    updateInfo() {
      this.$store
        .dispatch('user/updateInfo', this.infoTemp)
        .then(() => {
          this.$bvToast.toast('Cập nhật thông tin thành công', {
            title: 'Thành công',
            variant: 'success'
          })
        })
        .catch(error => {
          this.$bvToast.toast(this.get(error, 'response.data.error.message') || error.message, {
            title: 'Thất bại',
            variant: 'danger'
          })
        })
    },

    handleEditInfo() {
      this.$set(this, 'infoTemp', this.user)
      if (!this.infoTemp.contact) {
        Object.assign(this.infoTemp, {
          contact: {}
        })
      }
      this.infoDialog = true
    },

    get(obj, path) {
      return _.get(obj, path)
    },

    async init() {
      this.$store.dispatch('course/GetRatings', {
        page: this.ratingQuery.page,
        limit: this.ratingQuery.limit
      })
    }
  }
}
</script>

<style lang="scss">
.info-dialog {
  .btn-primary {
    background-color: #FF5A8D;
    border-color: #FF5A8D;
  }
}

.dashboard {
  .teacher-info {
    .info-block {
      .title {
        font-family: Inter;
        font-weight: bold;
        font-size: 24px;
        color: #2A3956;
      }

      .tool-box {
        background: #9BA4B2;
        border-radius: 24px; padding: 8px 12px;
        font-size: 14px;
      }

      .overview-card {
        .inner {
          background: #E9EFF8;
          border-radius: 20px;
          padding: 12px;
          .value {
            font-family: Muli;
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            color: #4F67E1;
          }
          .title {
            padding-top: 6px;
            font-family: 'Muli';
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            color: #848B96;
          }
        }
      }

      .teacher-about {
        .about-title {
          border-bottom: 1px solid #D8D7D6;
          .text {
            font-family: Muli;
            font-size: 16px;
            font-weight: bold;
            color: #000000;
          }
        }
      }

      .teacher-rating {
        .user-rating {
          background: #FFFFFF;
          border: 1px solid #FBF8F4;
          box-sizing: border-box;
          box-shadow: 0px 4px 5px rgba(227, 233, 242, 0.5);
          border-radius: 12px;
                  }

        .rating-header {
          position: relative;
          .avatar {
            border: 1px solid rgba(228, 228, 228, 0.6);
            box-sizing: border-box;
            width: 56px;
            height: 56px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: -28px;
          }

          .name-rating{
            padding-left: 68px;
            font-family: Muli;
            font-size: 13px;

            .form-control {
              padding: 0
            }
          }
        }

        .rating-time {
          font-family: Muli;
          font-size: 12px;
          color: #999999;
        }

        .rating-content {
          font-family: Muli;
          font-size: 13px;
          color: #403B36;
          min-height: 100px;
        }
      }
    }
  }
}
</style>
